<template>

    <div v-show="showShareMenu" class="floating-share-container" style="z-index:1500">
    <!-- Main Share Menu -->
    <div v-show="showShareMenu && activeSection === 'main'" class="share-menu">
        <div class="share-menu-header">
            <h3>Share your Allmyonline</h3>
            <button class="close-btn" @click="toggleShareMenu">&times;</button>
        </div>
        <p>Get more visitors by sharing your page everywhere.</p>

        <!-- Share Options -->
        <ul class="share-options">
            <li @click="activeSection = 'share-options'">
                <div class="icon-text">
                    <div class="icon-bg share-bg">
                        <i class="fas fa-share-alt"></i>
                    </div>
                    <span>Share my page to...</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="activeSection = 'qr-code'">
                <div class="icon-text">
                    <div class="icon-bg qr-bg">
                        <i class="fas fa-qrcode"></i>
                    </div>
                    <span>My QR Code</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="openMyPage">
                <div class="icon-text">
                    <div class="icon-bg open-bg">
                        <i class="fas fa-globe"></i>
                    </div>
                    <span>Open my AllMyOnline</span>
                </div>
                <i class="fas fa-external-link-alt right-arrow"></i>
            </li>
        </ul>

        <!-- Copyable Link -->
        <div class="copy-box">
            <div class="svg-logo">
                <svg width="108" height="104" viewBox="0 0 108 104" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <rect width="108" height="104" fill="url(#pattern0_146_36)"/>
                    <defs>
                        <pattern id="pattern0_146_36" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_146_36" transform="matrix(0.00573192 0 0 0.00595238 -0.00154321 0)"/>
                        </pattern>
                        <image id="image0_146_36" width="175" height="168" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                    </defs>
                </svg>
            </div>
            <AppButton
                width="70%"
                @buttonClick="copyLink"
                ignore-plan-restriction
            >
                {{ copyText }}
            </AppButton>
        </div>
    </div>
    <!-- Share Options Section -->
    <div v-if="showShareMenu && activeSection === 'share-options'" class="share-menu">
        <div class="share-menu-header">
            <button class="back-btn" @click="activeSection = 'main'">
                <i class="fas fa-arrow-left"></i>
            </button>
            <h3 class="center-title">Share to...</h3>
            <button class="close-btn" @click="toggleShareMenu">&times;</button>
        </div>
        <p>Share your page to all your connections so everyone knows about it.</p>

        <!-- More Sharing Options -->
        <ul class="share-options">
            <li @click="shareTo('snapchat')">
                <div class="icon-text">
                    <div class="icon-bg snapchat-bg">
                        <i class="fab fa-snapchat-ghost"></i>
                    </div>
                    <span>Share on Snapchat</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="shareTo('facebook')">
                <div class="icon-text">
                    <div class="icon-bg facebook-bg">
                        <i class="fab fa-facebook-f"></i>
                    </div>
                    <span>Share on Facebook</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="shareTo('linkedin')">
                <div class="icon-text">
                    <div class="icon-bg linkedin-bg">
                        <i class="fab fa-linkedin-in"></i>
                    </div>
                    <span>Share on LinkedIn</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="shareTo('twitter')">
                <div class="icon-text">

                    <div class="icon-bg twitter-bg">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" width="24px" height="24px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><path d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z"/></svg>

                    </div>
                    <span>Share on X</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="shareTo('whatsapp')">
                <div class="icon-text">
                    <div class="icon-bg whatsapp-bg">
                        <i class="fab fa-whatsapp"></i>
                    </div>
                    <span>Share via WhatsApp</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="shareTo('messenger')">
                <div class="icon-text">
                    <div class="icon-bg messenger-bg">
                        <i class="fab fa-facebook-messenger"></i>
                    </div>
                    <span>Share via Messenger</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
            <li @click="shareTo('email')">
                <div class="icon-text">
                    <div class="icon-bg email-bg">
                        <i class="fas fa-envelope"></i>
                    </div>
                    <span>Share via Email</span>
                </div>
                <i class="fas fa-chevron-right right-arrow"></i>
            </li>
        </ul>
    </div>
    <!-- QR Code Section -->
    <div v-if="showShareMenu && activeSection === 'qr-code'" class="share-menu">
        <div class="share-menu-header">
            <button class="back-btn" @click="activeSection = 'main'">
                <i class="fas fa-arrow-left"></i>
            </button>
            <h3 class="center-title">QR Code</h3>
            <button class="close-btn" @click="toggleShareMenu">&times;</button>
        </div>
        <p>Here is your unique QR code that will direct people to your page when scanned.</p>

        <!-- QR Code Image -->
        <div class="qr-code-container">
            <qrcode-vue
                :value="shareUrl"
                :size="200"
                level="H"
                ref="qrcodeCanvas">
            </qrcode-vue>
        </div>

    </div>

</div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import AppButton from "@/Components/AppButton.vue";

export default {
    name: 'ShareMenu',
    components: {AppButton, QrcodeVue },
    props: {
        showShareMenu: Boolean,
        activeSection: {
            type: String,
            default: 'main'
        },
        urlName: String,
        username: Object,
        shareCode: ''
    },
    data() {
        return {
            copyText: "Copy", // Default button text
            showMoreMenu: false, // Controls visibility of the dropdown
            activeSection: "main", // Controls which section is shown
            //shareUrl: (this.urlName + this.username).replace(/^https?:\/\//, ''),
            //shareUrl: this.urlName + this.username,
        };
    },
    computed: {
        shareUrl() {
            return this.urlName + this.shareCode;
        }
    },
    methods: {
        close() {
            this.showShareMenu = false;
        },
        toggleShareMenu() {
            const newState = !this.showShareMenu;
            this.$emit('update:showShareMenu', newState); // Tell parent to update it
            if (!newState) {
                this.activeSection = "main"; // Only reset if closing
            }
        },
        copyLink() {
            navigator.clipboard.writeText(this.shareUrl).then(() => {
                this.copyText = "Copied!"; // Change button text

                // Reset back to "Copy" after 3 seconds
                setTimeout(() => {
                    this.copyText = "Copy";
                }, 3000);
            });
        },
        openMyPage() {
            window.open(this.urlName + this.username, "_blank");
        },
        shareTo(platform) {
            const urls = {
                snapchat: "https://www.snapchat.com/share?url=" + this.shareUrl,
                facebook: "https://www.facebook.com/sharer/sharer.php?u=" + this.shareUrl,
                linkedin: "https://www.linkedin.com/shareArticle?url=" + this.shareUrl,
                twitter: "https://twitter.com/intent/tweet?url=" + this.shareUrl,
                whatsapp: "https://wa.me/?text=" + this.shareUrl,
                messenger: "https://www.messenger.com/new/?link=" + this.shareUrl,
                email: "mailto:?subject=Check this out&body=" + this.shareUrl
            };
            window.open(urls[platform], "_blank");
        },
    },
};
</script>
<style scoped>
/* Floating Share Button */
.floating-share-container {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 1000;
}

/* Share Menu */
.share-menu {

    background: white;
    width: 388px;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
}

/* Share Menu Header */
.share-menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 15px;

}

.share-menu h3 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}

.share-menu p {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

/* Close Button */
.close-btn {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
}

/* Share Options */
.share-options {
    list-style: none;
    padding: 0;
}

.share-options li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 15px;
    border-radius: 12px;
    transition: background 0.2s;
    cursor: pointer;
}
/* Icon Background Styling */
.icon-bg {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* Icon Colors */
.share-bg { background: #28A745; } /* Share */
.qr-bg { background: #FF8C00; } /* QR Code */
/* Icon Styling */
.icon-bg i {
    font-size: 18px;
    color: white;
}
/* Align Icon & Text */
.icon-text {
    display: flex;
    align-items: center;
    gap: 12px;
}
/* Share Icons */
/* Center the title */
.center-title {
    flex-grow: 1;
    text-align: center;
    margin: 0;
}
/* Right Arrow */
.right-arrow {
    color: #ccc;
    font-size: 16px;
}

/* Hover Effect */
.share-options li:hover {
    background: #f3f3f3;
}

/* Copyable Link */
.copy-box {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    padding: 12px;
    border-radius: 8px;
    margin-top: 15px;
}

/* Placeholder for SVG Logo */
.svg-logo {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
}

/* Copyable Link Text */
.copy-text {
    flex: 1;
    font-size: 15px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Copy Button */
.copy-box button {

    padding: 6px 12px;
    position: absolute;
    right: 30px;
    margin-top: 19px;
}

/* Back Button */
.back-btn {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    left: 15px;
}

/* QR Code Container */
.qr-code-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

/* Download Icons */
.share-options li a {
    color: #007BFF;
    font-size: 18px;
}

.allmyonline-icon i {
    font-size: 18px;
    color: black;
}

/* Align Icon & Text */
.icon-text {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* External Link Arrow */
.right-arrow {
    color: #666;
    font-size: 14px;
}

/* Icon Background Styling */
.icon-bg {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color:white;
}

/* Unique Background Colors */
.share-bg { background: #28A745; } /* Green */
.qr-bg { background: #FF8C00; } /* Orange */
.snapchat-bg { background: #FFFC00; color: black; } /* Yellow */
.facebook-bg { background: #1877F2; } /* Blue */
.linkedin-bg { background: #0077B5; } /* Blue */
.twitter-bg { background: none; } /* Black */
.whatsapp-bg { background: #25D366; } /* Green */
.messenger-bg { background: #0084FF; } /* Blue */
.email-bg { background: #D44638; } /* Red */
.open-bg { background: #D9EC2B; } /* Light Yellow-Green */

/* Icon Styling */
.icon-bg i {
    font-size: 18px;
    color: white;
}

/* Align Icon & Text */
.icon-text {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* External Link Arrow */
.right-arrow {
    color: #666;
    font-size: 14px;
}

</style>
